import { Trans, useLingui } from '@lingui/react/macro';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import Title from '@/design_system/Typography/Title';
import { getWorkflowStoreTypeLabel, Workflow } from '@/models/workflow';

export const StoreTypes = ({ workflow }: { workflow: Workflow }) => {
  const { i18n } = useLingui();

  const storeTypes =
    workflow.storeTypes.length > 0 ? workflow.storeTypes : (['internal', 'external'] as const);

  return (
    <Box gap="1rem">
      <Stack>
        <Title as="h2">
          <Trans id="settings.workflows.workflow.scope.store-types.title">Store types</Trans>
        </Title>
        <Paragraph size="200" color="secondary">
          <Trans id="settings.workflows.workflow.scope.store-types.description">
            Whether this workflow applies to internal stores, external stores, or both.
          </Trans>
        </Paragraph>
      </Stack>
      <Paragraph size="100" color="secondary">
        {storeTypes.map((storeType) => i18n._(getWorkflowStoreTypeLabel(storeType))).join(', ')}
      </Paragraph>
    </Box>
  );
};
